import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

const zhCNMessages = {
  "edu.pages.projects.title": "培训项目中心",
  "edu.pages.projects.subtitle": "这里治理的是培训项目执行实例，不是抽象模板库；当前工作面已经把项目方案、课程/考试步骤、标准解锁规则与项目完成边界收口到同一条执行主链。",
  "edu.pages.projects.notice": "培训项目页应保持正式后台列表形态：主列表走后端分页，右侧详情与下方执行结果保持业务工作区语义。",
  "edu.pages.projects.actions.publishThread": "发布主题",
  "edu.pages.projects.actions.sendNotice": "发送通知",
  "edu.pages.projects.actions.viewDetail": "查看详情",
  "edu.pages.projects.actions.viewCourseInstances": "课程执行实例",
  "edu.pages.projects.actions.viewExamResults": "考试执行结果",
  "edu.pages.projects.actions.saveMembers": "保存学员",
  "edu.pages.projects.actions.saveSteps": "保存路径",
  "edu.pages.projects.actions.moveUp": "上移",
  "edu.pages.projects.actions.moveDown": "下移",
  "edu.pages.projects.actions.pick": "查找带回",
  "edu.pages.projects.actions.clear": "清空",
  "edu.pages.projects.actions.manualRelease": "手动放开",
  "edu.pages.projects.actions.configureSteps": "编排项目路径",
  "edu.pages.projects.actions.configureMembers": "配置学员",
  "edu.pages.projects.actions.publishProject": "发布项目",
  "edu.pages.projects.actions.endProject": "结束项目",
  "edu.pages.projects.actions.submitPickedCourse": "带回已选课程",
  "edu.pages.projects.actions.submitPickedPaper": "带回已选试卷",
  "edu.pages.projects.actions.submitPickedMember": "带回已选学员",
  "edu.pages.projects.labels.focusItems": "当前关注",
  "edu.pages.projects.labels.currentDetail": "当前项目详情",
  "edu.pages.projects.labels.projectTitle": "培训项目",
  "edu.pages.projects.labels.projectDraft": "项目草稿",
  "edu.pages.projects.labels.projectStep": "路径步骤",
  "edu.pages.projects.labels.lifecycleStatus": "生命周期",
  "edu.pages.projects.labels.executionStatus": "执行状态",
  "edu.pages.projects.labels.unlockRules": "解锁规则",
  "edu.pages.projects.labels.completionRule": "完成判定",
  "edu.pages.projects.labels.examStepPaper": "考试节点 / 试卷",
  "edu.pages.projects.labels.projectStatus": "项目状态",
  "edu.pages.projects.labels.score": "成绩",
  "edu.pages.projects.labels.resultSource": "结果来源",
  "edu.pages.projects.labels.resultAt": "结果时间",
  "edu.pages.projects.labels.courseStepCourseVersion": "课程步骤 / 课程版本",
  "edu.pages.projects.labels.courseSchemeSnapshot": "课程方案快照",
  "edu.pages.projects.labels.instanceStatus": "实例状态",
  "edu.pages.projects.labels.learningRecords": "学习记录",
  "edu.pages.projects.labels.memberParticipation": "成员参与",
  "edu.pages.projects.labels.historyPrefix": "历史",
  "edu.pages.projects.labels.courseInstances": "课程执行实例",
  "edu.pages.projects.labels.learningFacts": "学习事实共享",
  "edu.pages.projects.labels.projectSummary": "项目说明",
  "edu.pages.projects.labels.arrangementSummary": "安排说明",
  "edu.pages.projects.labels.boardThreadSummary": "留言主题",
  "edu.pages.projects.labels.noticeSummary": "项目通知",
  "edu.pages.projects.labels.projectExamSummary": "项目级考试",
  "edu.pages.projects.labels.executionBoundary": "执行边界",
  "edu.pages.projects.labels.historyBoundary": "历史回看",
  "edu.pages.projects.labels.memberScale": "成员规模",
  "edu.pages.projects.labels.stepCount": "步骤数",
  "edu.pages.projects.labels.steps": "项目路径步骤",
  "edu.pages.projects.labels.notices": "项目通知留痕",
  "edu.pages.projects.labels.boardThreads": "项目留言主题",
  "edu.pages.projects.labels.nextActions": "下一步入口",
  "edu.pages.projects.labels.memberGroups": "项目学员执行分组",
  "edu.pages.projects.labels.courseExecutionInstances": "项目课程执行实例",
  "edu.pages.projects.labels.examResults": "项目考试执行结果",
  "edu.pages.projects.messages.emptyGroup": "当前分组暂无成员。",
  "edu.pages.projects.messages.emptyCourseInstances": "当前没有项目课程执行实例",
  "edu.pages.projects.messages.emptyExamResults": "当前没有项目考试结果",
  "edu.pages.projects.messages.detailLoadFailed": "培训项目详情加载失败",
  "edu.pages.projects.placeholders.emptyDetail": "请选择一个培训项目查看详情。",
  "edu.pages.projects.placeholders.emptyCourseInstances": "请选择一个培训项目查看课程执行实例。",
  "edu.pages.projects.placeholders.emptyExamResults": "请选择一个培训项目查看考试执行结果。",
  "edu.pages.projects.placeholders.emptyNoticeItems": "当前还没有项目通知留痕。",
  "edu.pages.projects.placeholders.emptyBoardThreads": "当前还没有项目留言主题。",
  "edu.pages.projects.messages.boardThreadTrace": "主题会进入培训项目真实留痕",
  "edu.pages.projects.messages.boardThreadTraceDescription": "学员在培训项目总览页、项目课程步骤和项目考试入口的留言板 TAB 会读取这些主题摘要；这里当前只维护主题摘要留痕。",
  "edu.pages.projects.messages.noticeTrace": "通知会进入培训项目真实留痕",
  "edu.pages.projects.messages.noticeTraceDescription": "学员在项目总览页会看到同一份项目通知留痕；消息中心继续承接跨课程、作业与考试的待办和已读历史。",
  "edu.pages.projects.messages.createDraft": "先创建项目本体草稿",
  "edu.pages.projects.messages.createDraftDescription": "草稿创建后可在项目详情中继续编排课程节点 / 考试节点路径、配置学员并发布；项目课程执行实例会在发布时生成，考试节点当前已按 AI Exam 试卷版本绑定。",
  "edu.pages.projects.messages.stepsDraftOnly": "当前只编排草稿项目的线性主路径",
  "edu.pages.projects.messages.stepsDraftOnlyDescription": "保存会整体替换该项目的课程节点 / 考试节点顺序。课程节点必须从 edu 课程库选择真实课程；考试节点必须从 AI Exam 试卷库选择真实试卷版本，保存时由后端自动回填规范化标题。",
  "edu.pages.projects.messages.memberBindingOnly": "培训项目只绑定学员",
  "edu.pages.projects.messages.memberBindingOnlyDescription": "培训项目不引入助教位；这里绑定的是具体人，组织树只作为批量选人和筛选包装。保存后会更新项目学员范围，但不会自动发布项目。",
  "edu.pages.projects.messages.loadFailed": "培训项目中心加载失败",
  "edu.pages.projects.messages.paperOptionsLoadFailed": "项目试卷候选加载失败",
  "edu.pages.projects.messages.stepsSaveFailed": "培训项目路径编排保存失败",
  "edu.pages.projects.messages.publishFailed": "培训项目发布失败",
  "edu.pages.projects.messages.endFailed": "培训项目结束失败",
  "edu.pages.projects.messages.manualReleaseFailed": "步骤手动放开失败",
  "edu.pages.projects.messages.noticeCreateFailed": "项目通知发送失败",
  "edu.pages.projects.messages.threadCreateFailed": "项目留言主题发布失败",
  "edu.pages.projects.messages.memberConfigFailed": "培训项目学员配置失败",
  "edu.pages.projects.confirm.manualReleaseTitle": "手动放开步骤",
  "edu.pages.projects.confirm.manualReleaseDescription": "放开后，该步骤对已指派学员进入已解锁状态，并自动沉淀一条项目通知留痕。",
  "edu.pages.projects.confirm.publishTitle": "发布培训项目",
  "edu.pages.projects.confirm.publishDescription": "发布后会按课程步骤生成项目课程执行实例，已指派学员才能在学员端看到该培训项目，同时自动沉淀一条项目发布通知。",
  "edu.pages.projects.confirm.endTitle": "结束培训项目",
  "edu.pages.projects.confirm.endDescription": "结束后项目进入历史回看语义，学员可回看但不再继续推进新的项目执行。",
  "edu.pages.projects.confirm.deleteStepTitle": "删除路径步骤",
  "edu.pages.projects.confirm.deleteStepDescription": "确认删除步骤 {index} 吗？该步骤的绑定课程或试卷配置会一并移除。",
  "edu.pages.projects.placeholders.threadTitle": "例如：项目案例讨论入口",
  "edu.pages.projects.placeholders.summary": "给学员看到的简短摘要，可留空。",
  "edu.pages.projects.placeholders.threadContent": "写下本次培训项目主题的详细内容。",
  "edu.pages.projects.placeholders.noticeTitle": "例如：本周培训安排调整",
  "edu.pages.projects.placeholders.noticeContent": "写下本次培训项目通知的详细内容。",
  "edu.pages.projects.placeholders.projectTitle": "例如：安全意识新员工培训",
  "edu.pages.projects.placeholders.schemeTitle": "默认：项目方案 v1",
  "edu.pages.projects.placeholders.projectDescription": "说明培训目标、适用对象、安排说明或注意事项。",
  "edu.pages.projects.placeholders.stepTitle": "例如：安全意识基础课程",
  "edu.pages.projects.placeholders.coursePicker": "从 edu 课程库查找带回课程",
  "edu.pages.projects.placeholders.paperPicker": "从 AI Exam 试卷库查找带回试卷版本",
  "edu.pages.projects.placeholders.emptyCoursePicker": "当前没有可供带回的课程。",
  "edu.pages.projects.placeholders.emptyPaperPicker": "当前没有可供带回的试卷版本。",
  "edu.pages.projects.placeholders.emptyMemberPicker": "当前没有可供带回的成员。",
  "edu.pages.projects.placeholders.unlockRule": "例如：完成上一节点后解锁",
  "edu.pages.projects.placeholders.completionSummary": "例如：该课程内所有必修课时完成",
  "edu.pages.projects.placeholders.stepLimit": "最多 32 个步骤；如果清空所有步骤并保存，项目会回到“路径尚未编排”的草稿状态。",
  "edu.pages.projects.placeholders.memberPicker": "查找带回项目学员",
  "edu.pages.projects.modals.threadTitle": "发起项目留言主题",
  "edu.pages.projects.modals.noticeTitle": "发送培训项目通知",
  "edu.pages.projects.modals.createTitle": "新建培训项目草稿",
  "edu.pages.projects.modals.stepsTitle": "编排项目路径",
  "edu.pages.projects.modals.memberTitle": "配置培训项目学员",
  "edu.pages.projects.modals.coursePickerTitle": "选择课程节点",
  "edu.pages.projects.modals.paperPickerTitle": "选择试卷节点",
  "edu.pages.projects.modals.memberPickerTitle": "选择项目学员",
  "edu.pages.projects.forms.threadTitleLabel": "主题标题",
  "edu.pages.projects.forms.threadTitleRequired": "请输入主题标题",
  "edu.pages.projects.forms.threadTitleMax": "主题标题不能超过 128 个字符",
  "edu.pages.projects.forms.threadSummaryLabel": "主题摘要",
  "edu.pages.projects.forms.threadSummaryMax": "主题摘要不能超过 256 个字符",
  "edu.pages.projects.forms.threadContentLabel": "主题正文",
  "edu.pages.projects.forms.threadContentRequired": "请输入主题正文",
  "edu.pages.projects.forms.threadContentMax": "主题正文不能超过 4000 个字符",
  "edu.pages.projects.forms.noticeTitleLabel": "通知标题",
  "edu.pages.projects.forms.noticeTitleRequired": "请输入通知标题",
  "edu.pages.projects.forms.noticeTitleMax": "通知标题不能超过 128 个字符",
  "edu.pages.projects.forms.noticeSummaryLabel": "通知摘要",
  "edu.pages.projects.forms.noticeSummaryMax": "通知摘要不能超过 256 个字符",
  "edu.pages.projects.forms.noticeContentLabel": "通知正文",
  "edu.pages.projects.forms.noticeContentRequired": "请输入通知正文",
  "edu.pages.projects.forms.noticeContentMax": "通知正文不能超过 4000 个字符",
  "edu.pages.projects.forms.projectTitleLabel": "项目名称",
  "edu.pages.projects.forms.projectTitleRequired": "请输入培训项目名称",
  "edu.pages.projects.forms.projectTitleMax": "项目名称不能超过 128 个字符",
  "edu.pages.projects.forms.schemeTitleLabel": "项目方案标题",
  "edu.pages.projects.forms.schemeTitleMax": "项目方案标题不能超过 128 个字符",
  "edu.pages.projects.forms.projectDescriptionLabel": "项目说明",
  "edu.pages.projects.forms.projectDescriptionMax": "项目说明不能超过 512 个字符",
  "edu.pages.projects.forms.stepTitleLabel": "步骤标题",
  "edu.pages.projects.forms.stepTitleRequired": "请输入步骤标题",
  "edu.pages.projects.forms.stepTitleMax": "步骤标题不能超过 128 个字符",
  "edu.pages.projects.forms.nodeTypeLabel": "节点类型",
  "edu.pages.projects.forms.nodeTypeRequired": "请选择节点类型",
  "edu.pages.projects.forms.boundCourseLabel": "绑定课程",
  "edu.pages.projects.forms.boundCourseRequired": "请选择真实课程",
  "edu.pages.projects.forms.boundCourseRetry": "请重新选择真实课程",
  "edu.pages.projects.forms.boundPaperLabel": "绑定试卷",
  "edu.pages.projects.forms.boundPaperRequired": "请选择真实试卷版本",
  "edu.pages.projects.forms.boundPaperRetry": "请重新选择真实试卷版本",
  "edu.pages.projects.forms.requiredForCompletionLabel": "是否计入项目完成",
  "edu.pages.projects.forms.requiredForCompletionRequired": "请选择是否计入项目完成",
  "edu.pages.projects.forms.unlockTemplateLabel": "解锁模板",
  "edu.pages.projects.forms.unlockTemplateRequired": "请选择解锁模板",
  "edu.pages.projects.forms.releaseTimeLabel": "放开时间",
  "edu.pages.projects.forms.releaseTimePlaceholder": "仅指定时间解锁时需要配置",
  "edu.pages.projects.forms.releaseTimeRequired": "请选择自动放开时间",
  "edu.pages.projects.forms.unlockRuleSummaryLabel": "解锁规则摘要",
  "edu.pages.projects.forms.unlockRuleSummaryRequired": "请输入解锁规则摘要",
  "edu.pages.projects.forms.unlockRuleSummaryMax": "解锁规则摘要不能超过 128 个字符",
  "edu.pages.projects.forms.completionSummaryLabel": "完成条件摘要",
  "edu.pages.projects.forms.completionSummaryRequired": "请输入完成条件摘要",
  "edu.pages.projects.forms.completionSummaryMax": "完成条件摘要不能超过 128 个字符",
  "edu.pages.projects.forms.memberLabel": "学员",
  "edu.pages.projects.values.paperVersionUnknown": "未标注版本",
  "edu.pages.projects.values.paperCodeUnset": "未配置编码",
  "edu.pages.projects.values.defaultMemberRole": "成员",
  "edu.pages.projects.values.unlockTemplatePreviousStep": "完成上一节点",
  "edu.pages.projects.values.unlockTemplateScheduledTime": "到达指定时间",
  "edu.pages.projects.values.unlockTemplateManualRelease": "管理员手动放开",
  "edu.pages.projects.values.defaultUnlockRuleFirstStep": "由项目管理人手动放开后解锁",
  "edu.pages.projects.values.defaultUnlockRuleNextStep": "完成上一节点后解锁",
  "edu.pages.projects.values.defaultCompletionSummary": "完成该节点要求",
  "edu.pages.projects.labels.requiredCompletionSummary": "必完成项 {completed}/{total}",
  "edu.pages.projects.labels.completedAt": "完成于 {value}",
  "edu.pages.projects.labels.noticeTitleTemplate": "{title} 通知",
  "edu.pages.projects.labels.threadTitleTemplate": "{title} 留言主题",
  "edu.pages.projects.labels.scheduledReleaseAuto": "到达指定时间后自动放开",
  "edu.pages.projects.labels.scheduledReleaseAt": "计划放开时间：{value}",
  "edu.pages.projects.labels.manualReleasedAt": "已手动放开：{value} · {operator}",
  "edu.pages.projects.labels.pendingManualRelease": "待项目管理人手动放开",
  "edu.pages.projects.labels.defaultManualReleaseOperator": "项目管理人",
  "edu.pages.projects.labels.timestampUnset": "时间未配置",
  "edu.pages.projectCourseInstances.title": "项目课程执行实例",
  "edu.pages.projectCourseInstances.subtitle": "这里按培训项目读取真实课程步骤执行实例，不再把项目详情页继续混成下方执行工作台。",
  "edu.pages.projectCourseInstances.notice": "该页面只展示当前培训项目已生成的课程执行实例事实；刷新会同时重拉项目详情和实例列表。",
  "edu.pages.projectCourseInstances.labels.totalCount": "实例总数",
  "edu.pages.projectCourseInstances.messages.loadFailed": "项目课程执行实例加载失败",
  "edu.pages.projectCourseInstances.messages.invalidProjectId": "当前项目 ID 非法，无法读取课程执行实例。",
  "edu.pages.projectExamResults.title": "项目考试执行结果",
  "edu.pages.projectExamResults.subtitle": "这里按培训项目读取真实考试结果事实，不再把项目详情页继续混成下方执行工作台。",
  "edu.pages.projectExamResults.notice": "该页面只展示当前培训项目已写入的考试结果事实；刷新会同时重拉项目详情和结果列表。",
  "edu.pages.projectExamResults.labels.totalCount": "结果总数",
  "edu.pages.projectExamResults.messages.loadFailed": "项目考试执行结果加载失败",
  "edu.pages.projectExamResults.messages.invalidProjectId": "当前项目 ID 非法，无法读取考试执行结果。",
} satisfies MessageTree;

export const eduProjectsPageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": zhCNMessages,
  en: zhCNMessages,
  ja: zhCNMessages,
};
